import React, { useState} from 'react';
import { Link, useNavigate } from 'react-router-dom'; // for navigation
import axios from 'axios'; // for making API requests
import Swal from 'sweetalert2'; // for SweetAlert2 popups
import { Button, Form, Row, Alert } from 'react-bootstrap'; // for form components
import './Login.css';
import Logo from "../../Image/MainLogo.png"

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null); // for storing errors
  const [validated, setValidated] = useState(false); // for form validation
  const navigate = useNavigate();

  // Check if user is already logged in and redirect to dashboard
  // useEffect(() => {
  //   const authUser = localStorage.getItem('authUser');
  //   if (authUser) {
  //     navigate('/');
  //   }
  // }, [navigate]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

   
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    setLoading(true); 
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}api/admin/login`, {
        email,
        password,
      });

      setLoading(false); 

      const response = res.data;
      console.log('Login Response:', response); // Debugging the response

      // Handle error response
      console.log('sfdaggggg',response);

      if (response.status === 0) {
        // Check for specific error messages
      
        

        if (response.errors && response.errors.email) {
          setError(response.errors.email);
          // Swal.fire('Error', 'Invalid email. Please try again.', 'error');
        } else if (response.errors && response.errors.password) {
          setError(response.errors.password);
          // Swal.fire('Error', 'Invalid password. Please try again.', 'error');
        } else {
          setError('Invalid credentials. Please try again.');
          // Swal.fire('Error', 'Invalid credentials. Please try again.', 'error');
        }
      } else {
        setError(null); // Clear any previous error
        Swal.fire('Success', 'Login Successful!', 'success');

        // Store user data in localStorage
        localStorage.setItem('authUser', JSON.stringify(response));

        // const authUser = localStorage.getItem('authUser');
        // console.log("authuserData==>>", authUser);
        

        // Redirect to dashboard
          navigate('/');
      }
    } catch (error) {
      setLoading(false); // Stop loading in case of error
      setError(error.response?.data?.message || 'An error occurred'); // Set error state
      console.error('Login error:', error); // Log the error for debugging
      Swal.fire('Error', 'An error occurred during login.', 'error');
    }
  };

  return (
    <section className='LoginSec'>
      <div className="LogDetailDiv">
        <div className="SiteLogo">
          <Link to="/"><img src={Logo} alt="Logo" /></Link>
        </div>
        <div className="LoginFormDiv">
          <div className="formHead">
            <h4>Login to Your Account</h4>
            <p>Enter your email & password to login</p>
          </div>

          {/* Display error message */}
          {error && <Alert variant="danger">{error}</Alert>}

          {/* Login Form */}
          <Form noValidate validated={validated} onSubmit={handleSubmit}>

            <Row>

              <Form.Group className="LogFormGroup" controlId="formBasicEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required />
                  <Form.Control.Feedback type="invalid">
                    Please enter a valid email.
                  </Form.Control.Feedback>
              </Form.Group>


              <Form.Group className="LogFormGroup" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required />
                <Form.Control.Feedback type="invalid">
                Your password must be 8-20 characters long, contain letters and numbers, and must not contain spaces, special characters, or emoji.
                </Form.Control.Feedback>
              </Form.Group>

            </Row>

            <div className="LogBtn">
              <Button type="submit" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </div>

          </Form>
        </div>
      </div>
    </section>
  );
};

export default Login;
